import { Check, X } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { CERT_OPTIONS } from "@/lib/labels";

export function RequiredCertsInput({ value, onChange }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid="job-required-certs">
      {Object.entries(CERT_OPTIONS).map(([k, l]) => (
        <label key={k} className="flex items-center gap-2 text-sm cursor-pointer">
          <Checkbox checked={value.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`job-cert-${k}`} />{l}
        </label>
      ))}
    </div>
  );
}

export function CertMatchPills({ certs = [], match, testId }) {
  if (!certs.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {certs.map((k) => {
        const has = match?.[k];
        const cls = match == null ? "bg-slate-50 text-slate-700 border-slate-200"
          : has ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200";
        return (
          <span key={k} data-testid={testId ? `${testId}-${k}` : undefined} data-has={match == null ? undefined : String(!!has)}
            className={`inline-flex items-center gap-1 border px-2 py-0.5 rounded text-xs ${cls}`}>
            {match != null && (has ? <Check size={12} /> : <X size={12} />)}{CERT_OPTIONS[k] || k}
          </span>
        );
      })}
    </div>
  );
}
